import Alpine from 'alpinejs';
import axios from '../../config/axios.js';

const API = '/api/v1/kasir/engagement/vouchers';

function emptyForm() {
  return {
    code: '',
    name: '',
    description: '',
    type: 'percentage',
    discount_value: 10,
    max_discount: null,
    min_transaction: 0,
    max_use: null,
    max_use_per_user: 1,
    is_active: true,
    visibility: 'both',
    show_on_welcome: true,
    expired_at_local: '',
  };
}

function createKasirVouchers() {
  return {
    loading: true,
    saving: false,
    items: [],
    search: '',
    modal: false,
    editing: null,
    form: emptyForm(),
    meta: { total: 0 },

    async init() {
      await this.load();
    },

    formatRp(n) {
      return 'Rp ' + Number(n || 0).toLocaleString('id-ID');
    },

    typeLabel(t) {
      return ({ percentage: 'Persentase', fixed: 'Nominal', free_shipping: 'Gratis Ongkir' })[t] || t;
    },

    valueLabel(v) {
      if (v.type === 'free_shipping') return 'Ongkir gratis';
      if (v.type === 'percentage') return v.discount_value + '%';
      return this.formatRp(v.discount_value);
    },

    visibilityLabel(v) {
      return v.visibility_label || ({ web: 'Web saja', app: 'Aplikasi saja', both: 'Web & Aplikasi' })[v.visibility] || v.visibility;
    },

    async load() {
      this.loading = true;
      try {
        const { data } = await axios.get(API, { params: { q: this.search || undefined, per_page: 50 } });
        this.items = data.data || [];
        this.meta = {
          total: data.meta?.total ?? this.items.length,
        };
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal memuat voucher.', 'error');
      } finally {
        this.loading = false;
      }
    },

    openForm() {
      this.editing = null;
      this.form = emptyForm();
      this.modal = true;
    },

    edit(v) {
      this.editing = v;
      this.form = {
        code: v.code,
        name: v.name,
        description: v.description || '',
        type: v.type,
        discount_value: v.discount_value,
        max_discount: v.max_discount,
        min_transaction: v.min_transaction,
        max_use: v.max_use,
        max_use_per_user: v.max_use_per_user,
        is_active: v.is_active,
        visibility: v.visibility || 'both',
        show_on_welcome: v.show_on_welcome !== false,
        expired_at_local: v.expired_at ? v.expired_at.slice(0, 16) : '',
      };
      this.modal = true;
    },

    closeModals() {
      this.modal = false;
      this.editing = null;
    },

    async save() {
      this.saving = true;
      try {
        const payload = {
          ...this.form,
          code: String(this.form.code || '').toUpperCase(),
          expired_at: this.form.expired_at_local || null,
        };
        delete payload.expired_at_local;

        if (this.editing?.id) {
          await axios.put(`${API}/${this.editing.id}`, payload);
        } else {
          await axios.post(API, payload);
        }
        window.toast?.('Kode promo disimpan.', 'success');
        this.closeModals();
        await this.load();
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal menyimpan.', 'error');
      } finally {
        this.saving = false;
      }
    },

    async remove(v) {
      if (!confirm(`Hapus kode ${v.code}?`)) return;
      try {
        await axios.delete(`${API}/${v.id}`);
        window.toast?.('Kode promo dihapus.', 'success');
        await this.load();
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal menghapus.', 'error');
      }
    },
  };
}

Alpine.data('kasirVouchers', createKasirVouchers);
